import { DatePicker, InputNumber } from 'antd';
import styled from 'styled-components';

export const StyledDatePicker = styled(DatePicker)`
  width: 100%;
`;

export const StyledInputNumber = styled(InputNumber)`
  width: 100% !important;
`;